import { Injector } from "@angular/core";
import { BaseNode } from "../../BaseNode";
import { SubstanceTranslationEntity } from "../../../Data/MedicinalProductData/SubstanceTranslationEntity";
import { LookupGetService } from "../../../../service/lookup-service/lookup-get.service";
import { Art57Section } from "../../../Art57Section/Art57Section";
import { environment } from "../../../../../../environments/environment";

export class TreeNodeSubstanceTranslation extends BaseNode {

    constructor(injector: Injector, model: any, parent:any) {

        super(injector,
            new SubstanceTranslationEntity(injector, model),
            `${injector.get(LookupGetService).retrieveValueFromCache('language', model.languagecode)} 
            - ${model.term}`
);

        this.parent=parent;
        this.ioc!.get(Art57Section).generateNumColumValue(this);
    }

    public getListItem(): any[] {
        return [
            this.ioc!.get(LookupGetService).retrieveValueFromCache(
                'language',
                this.data.model.languagecode
            ),
            this.data.model.term
        ];
    }

    override cloneNode(newParent: BaseNode): BaseNode|undefined {

      let clonedNode: TreeNodeSubstanceTranslation = new TreeNodeSubstanceTranslation(
        this.ioc!,
        this.data.model,
        newParent
      );
  
      clonedNode.data.model = JSON.parse(JSON.stringify(this.data.model));
      clonedNode.refreshLabel();  
      clonedNode.expanded = this.expanded && (environment.userPreferences.autoexpandNodesOnCloning ||environment.userPreferences.alwaysAutoexpandNodes)

      this.children?.forEach((child) => {
        let childToClone = child as BaseNode;
        let clonedChildren = childToClone.cloneNode(clonedNode);
        if (clonedChildren) {
            clonedNode.children?.push(clonedChildren);
            clonedChildren.refreshLabel();
        }
      });
  
// property doesn't exist      clonedNode.cloningNode = false;
      return clonedNode; 
    }    
}